import * as Yup from 'yup';
import { emailSchema, mainUserFormSchema } from '../userFormValidations';

const conclusionSchema = Yup.object().shape(
  {
    email: Yup.reach(emailSchema, 'email'),
    emailConfirmation: Yup.reach(emailSchema, 'emailConfirm'),
    cellPhone: Yup.reach(mainUserFormSchema, 'cellPhone'),
    phone: Yup.reach(mainUserFormSchema, 'phone'),
    hasAgreed: Yup.boolean().test(
      'required',
      'validationErrors.isRequired',
      (value) => !!value,
    ),
  },
  [['cellPhone', 'phone']],
);

export default conclusionSchema;
